import { ITaskItem } from "./shared";

export interface IRevokeProjectAdminRightsRequest {
    UserPrincipalName: string;  // The user principal name of the person we're revoking rights from
}

export interface IRevokeProjectAdminRightsResponse {
    ProjectSlug: string;
    id: string;
    UserPrincipalName?: string;
    BoardId: string;
    RequestedDate: Date;
    RequestedBy: string; // This is the "sub" claim from the access token.
    Status: string; // TODO: Change it to enum types. Find statuses from the state machine doc
    TaskItems: ITaskItem[];
}

export enum CreateRevokeProjectAdminRightsValidationFailureReasonEnum {
    Indeterminate = "Indeterminate",
    ProjectNotFound = "ProjectNotFound",
    AuthenticatedUserDoesNotHavePermission = "AuthenticatedUserDoesNotHavePermission",
    UserWeAreTryingToRevokeIsNotAProjectAdmin = "UserWeAreTryingToRevokeIsNotAProjectAdmin",
    InFlightRevokeProjectAdminRights = "InFlightRevokeProjectAdminRights",
    InFlightProjectTeamAssignments = "InFlightProjectTeamAssignments",
    InFlightProjectAdminAssignments = "InFlightProjectAdminAssignments",
    InFlightJoinProjects = "InFlightJoinProjects",
    InFlightLeaveProjects = "InFlightLeaveProjects",
    InFlightOffboardings = "InFlightOffboardings",
    ProjectAdminCannotRevokeProjectAdminRightsFromThemself = "ProjectAdminCannotRevokeProjectAdminRightsFromThemself",
}

export interface IRevokeProjectAdminRightsErrorResponse {
    ValidationFailureReason: CreateRevokeProjectAdminRightsValidationFailureReasonEnum;
}
